import React from "react";
import { View } from "react-native";

const Separator = (props) => {
    return (
        <View style={{ height: 1, width: '100%', backgroundColor: props.color != undefined ? props.color : '#000' }} />
    )
}

export default Separator;